function display(vueApp, message, closeMessage, isIndefinite) {
    vueApp.$snackbar.open({
    duration: 3500,
    message: message,
    type: "is-danger",
    position: "is-bottom-left",
    indefinite: isIndefinite,
    actionText: closeMessage,
    queue: false
  });
}

module.exports = {
    display : display,
}


// WEBPACK FOOTER //
// ./src/displayMessage.js